// Dependencies
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class ProyectoDetalle extends Component {
    componentDidMount() {
        /* eslint-disable */
        $.HSCore.components.HSCubeportfolio.init('.cbp');
    }
    render() {
        return (
            <div>
                <nav className="text-left" aria-label="Page Navigation">
                        <Link
                            className="btn g-py-2 g-px-10 u-btn-outline-primary"
                            to="/casos-de-exito"
                        >
                            <i className="icon-action-undo g-mr-10"></i>
                            Volver
                        </Link>
                </nav>
                <div className="row g-py-30">
                    <div className="col-md-8">
                        <div
                            className="cbp cbp-caption-active cbp-caption-overlayBottomAlong cbp-ready"
                            data-controls="#filterControls1"
                            data-animation="quicksand"
                            data-x-gap="30"
                            data-y-gap="30"
                            data-grid-adjustment="responsive"
                            data-media-queries='[{"width": 1500, "cols": 3}, {"width": 1100, "cols": 3}, {"width": 800, "cols": 3}, {"width": 480, "cols": 2}, {"width": 300, "cols": 1}]'
                        >
                            {this.props.images.map((item, key) => (
                                <div key={key} className="cbp-item identity">
                                    <div className="u-block-hover g-parent">
                                        <img
                                            className="img-fluid g-transform-scale-1_1--parent-hover g-transition-0_5 g-transition--ease-in-out"
                                            src={require('../assets/img/proyectos' + item)}
                                            alt="Imagen"
                                        />
                                        <a
                                            href={require('../assets/img/proyectos' + item)}
                                            style={{
                                                textAlign: "center",
                                                padding: "0px !important",
                                                width: "100%",
                                                height: "100%",
                                                display: "flex !important",
                                                alignItems: "end",
                                                justifyContent: "center",
                                                position: "absolute !important",
                                                marginLeft: "auto",
                                                marginRight: "auto"
                                            }}
                                            className="cbp-lightbox u-icon-v2 g-brd-0 u-icon-size--sm g-color-white g-bg-black d-flex g-bg-black-opacity-0_6 opacity-0 g-opacity-0_8--parent-hover g-pos-abs g-top-0 g-left-0 g-transition-0_3 g-transition--ease-in u-block-hover__additional--fade u-block-hover__additional--fade-in g-pa-20"
                                        >
                                            <i className="fa fa-search"></i>
                                        </a>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="mb-2">
                            <p className="font-weight-bold">{this.props.date}</p>
                            <p>{this.props.texto}</p>
                            {this.props.hitos.map((hito, key) => (
                                <p key={key}>
                                    <i className="icon-check g-color-primary g-mt-5 g-mr-10"></i> {hito}
                                </p>
                            ))}
                        </div>
                        <ul className="u-list-inline mb-0">
                            {this.props.tags.map((item, key) => (
                                <li key={key} className="list-inline-item g-mb-10">
                                    <a
                                        className="u-tags-v1 g-color-main g-brd-around g-brd-gray-light-v3 g-bg-gray-dark-v2--hover g-brd-gray-dark-v2--hover g-color-white--hover g-rounded-50 g-py-4 g-px-15"
                                        href="#!"
                                    >
                                        {item}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <nav className="text-left" aria-label="Page Navigation">
                        <Link
                            className="btn g-py-2 g-px-10 u-btn-outline-primary"
                            to="/casos-de-exito"
                        >
                            <i className="icon-action-undo g-mr-10"></i>
                            Volver
                        </Link>
                </nav>
            </div>
        );
    }
}

export default ProyectoDetalle;



// WEBPACK FOOTER //
// ./src/subcomponents/ProyectoDetalle.js